import React, { ReactNode, useEffect } from 'react';
import { getEnvExpressApiUrl } from '../configs/api/enviroments';
import { EXPRESS_API } from '../configs/api/expressApi';
import { APP_ENVIROMENT_TYPE } from '../configs/api/types';

export interface UserData {
  customer: {
    business: string;
    hasCovideoMagic: boolean;
    markVideosAsSent: number | null;
  };
  isAutomotiveServiceRole: boolean;
  isAutomotiveSalesRole: boolean;
  isAutomotive: boolean;
  firstName: string;
  isIMSEnabled: boolean;
  isCompanyAdmin: boolean;
}

interface IAuthContext {
  userData: UserData;
}

interface IProps {
  children: ReactNode;
  userData: UserData;
  token: string;
  env?: APP_ENVIROMENT_TYPE;
  apiKey?: string;
}

export const AuthContext = React.createContext({} as IAuthContext);

export const AuthProvider = ({
  children,
  userData,
  token,
  env,
  apiKey,
}: IProps) => {
  useEffect(() => {
    if (env) {
      EXPRESS_API.defaults.baseURL = getEnvExpressApiUrl(env);
    }
    if (apiKey) {
      EXPRESS_API.defaults.headers['apikey'] = apiKey;
    }

    if (token) {
      EXPRESS_API.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }, []);

  return (
    <AuthContext.Provider value={{ userData }}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
};
